import { useEffect } from 'react'

import { useZero } from '@rocicorp/zero/react'

import { queries } from '#zero/queries.ts'

/**
 * Keeps full task detail synced for every active task (any non-archived task
 * whose current run is not completed/cancelled), so switching between tasks
 * renders instantly from local data instead of flashing the page skeleton.
 */
export function usePreloadActiveTaskDetails(workspaceId: string) {
  const zero = useZero()

  useEffect(() => {
    const { cleanup } = zero.preload(
      queries.implementations.activeDetails({ workspaceId }),
    )
    return cleanup
  }, [zero, workspaceId])
}
